/**
 * Service de contenu — appels API publics avec fallback siteData.js
 * Utilisé par le front-office pour lire les données gérées depuis l'admin.
 */

const API = 'https://api.techtalentaccelerator.com';

async function safeFetch(endpoint) {
  try {
    const res = await fetch(`${API}${endpoint}`, {
      headers: { 'Content-Type': 'application/json' },
    });
    if (!res.ok) return null;
    const json = await res.json();
    return json.data ?? json;
  } catch {
    return null;
  }
}

export const getPublicFormations  = () => safeFetch('/public/formations');
export const getPublicArticles    = () => safeFetch('/public/articles');
export const getPublicProjets     = () => safeFetch('/public/projets');
export const getPublicSettings    = () => safeFetch('/public/settings');
export const getPublicPartenaires = () => safeFetch('/public/partenaires');
